module.exports = __webpack_public_path__ + "static/session-in-numbers-0c867fb86f5ec5e927b65afbaf554734.jpg";